import { styled } from '@material-ui/core';
import BaseButton from '../BaseButton';

const getColourFromVariant = (variant, theme) => {
  switch (variant) {
    case 'secondary':
      return {
        colour: theme.palette.xpl.stoke,
        fontColour: theme.palette.xpl.text.primary,
        hoverColour: theme.palette.xpl.secondary.hover,
      };
    case 'slighter':
      return {
        colour: theme.palette.common.osloGray,
        fontColour: theme.palette.xpl.text.primary,
        hoverColour: theme.palette.common.nevada,
      };
    case 'warning':
      return {
        colour: theme.palette.xpl.stoke,
        fontColour: theme.palette.xpl.text.warning,
        hoverColour: theme.palette.xpl.text.warning,
      };      
    default:
      return {
        colour: theme.palette.common.primary,
        fontColour: theme.palette.xpl.text.primary,
        hoverColour: theme.palette.common.primary700,
      };
  }
};

export const OutlinedButtonComponent = styled(BaseButton)(
  ({ variant, theme }) => {
    const { colour, hoverColour, fontColour } = getColourFromVariant(variant, theme);
    return {
      border: `1px solid ${colour}`,
      color: fontColour,
      fontWeight: 500,
      backgroundColor: theme.palette.xpl.foreground,
      '&:hover': {
        borderColor: hoverColour,
        // Helps remove sticky effect on mobile devices.
        '@media (hover: none)': {
          borderColor: colour,
        },
      },
      '@media (hover: none)': {
        '&:focus': {
          borderColor: hoverColour,
        },
      },
      '&:disabled': {
        opacity: '0.5',
      },
    };
  }
);
